<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">创建套餐</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="120px">
        <el-form-item label="套餐名称:"> <el-input v-model="basicInfo.name" :disabled="disabled"></el-input> </el-form-item>
        <el-form-item label="套餐等级:"> <el-input v-model.number="basicInfo.level" :disabled="disabled"></el-input> </el-form-item>
        <el-form-item label="描述:"> <el-input v-model="basicInfo.describe" type="textarea" :disabled="disabled"></el-input> </el-form-item>
        <el-form-item label="套餐原价:"> <el-input v-model="basicInfo.originalPrice" :disabled="disabled"></el-input> </el-form-item>
        <el-form-item label="套餐价格:"> <el-input v-model="basicInfo.price" :disabled="disabled"></el-input> </el-form-item>
        <el-form-item label="是否推荐:">
          <el-switch v-model="basicInfo.recommend" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="disabled">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否为体验套餐:">
          <el-switch v-model="basicInfo.freePlan" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="disabled">
          </el-switch>
        </el-form-item>
        <el-form-item label="活动套餐图片：" prop="photoUrl" v-if="basicInfo.freePlan">
          <el-upload :class="{ hide_uploadbtn: basicInfo.photoUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-remove="(e) => removeAppImage(e, 'ban')"
            :file-list="basicInfo.photoUrl" :http-request="(e) => uploadAppImage(e, 'ban')" :multiple="false" :limit="1">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p style="color: #999;line-height: 22px;">仅可上传一张图片</p>
        </el-form-item>
        <el-form-item label="有效期:">
          <el-input v-model="basicInfo.durationValue" :disabled="disabled"></el-input>
          <el-select v-model="basicInfo.durationUnit" placeholder="请选择" class="customer-select" :disabled="disabled">
            <el-option :label="item.label" :value="item.value" v-for="item in durationUnitList" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联权益:">
          <el-select v-model="basicInfo.configIdList" placeholder="请选择" class="customer-select" multiple :disabled="disabled">
            <el-option :label="item.label" :value="item.value" v-for="item in configIdList" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权益详情:">
          <div v-for="(item, index) in legalRightList" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="item.name" :disabled="disabled"></el-input>
            <i class="el-icon-delete" @click="legalRightDelete(index)" v-if="!disabled"></i>
            <i class="el-icon-sort" style="margin-left: 10px;" @click="legalRightSort(index)" v-if="!disabled"></i>
          </div>
          <el-button type="primary" icon="el-icon-plus" @click="addLegalRight" v-if="!disabled">新增权益详情</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="submit" v-if="!$route.query.id">确定</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)" v-else>返回</el-button>
    </div>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { membershipPlanId, storeQueryByStoreId, checkStoreCode, storeAuditStore, membershipPlanAdd } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      durationUnitList: [
        {
          value: 'DAY',
          label: '天'
        },
        {
          value: 'MONTH',
          label: '月'
        },
        {
          value: 'YEAR',
          label: '年'
        }
      ],
      configIdList: [
        {
          value: 1,
          label: 'AI分片'
        },
        {
          value: 2,
          label: '云照片'
        }, {
          value: 3,
          label: '预约管理'
        }, {
          value: 4,
          label: '客资管理'
        }, {
          value: 5,
          label: '营销管理'
        }
      ],
      legalRightList: [{ name: '' }],
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        photoUrl: []
      },
      disabled: false,
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    let id = this.$route.query.id
    if (id) {
      this.disabled = true
      membershipPlanId(id).then((res) => {
        if (res.data.success) {
          this.basicInfo = res.data.data
          if (this.basicInfo.photoUrl) {
            this.basicInfo.photoUrl = [{ url: this.basicInfo.photoUrl }]
          } else {
            this.basicInfo.photoUrl = []
          }
          this.basicInfo.freePlan = Number(this.basicInfo.freePlan)
          this.legalRightList = res.data.data.configDetailList.map(a => {
            return {
              name: a
            }
          })
        }
      })
    }
  },
  methods: {
    uploadAppImage (e, type) {
      console.log('e', e)
      // if (e.file.size > 1024 * 1024 * 10) {
      //   this.$message.error('图片大小不能超过10M')
      // }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          if (type == 'ban') {
            this.basicInfo.photoUrl.push({ url: res })
          }
          this.showPcImage = false
          this.$refs.basicInfo.validateField('photoUrl')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    removeAppImage (val, type) {
      console.log('removeAppImage', val)
      this.basicInfo.photoUrl = []
      // this.bannerForm.bannerUrl = ''
    },
    addLegalRight () {
      this.legalRightList.push({ name: '' })
    },
    legalRightDelete (index) {
      // this.legalRightList
      if (this.legalRightList.length > 1) {
        this.legalRightList.splice(index, 1)
      }
    },
    legalRightSort (index) {

    },
    // 确认提交
    submit () {
      console.log('this.basicInfo.price', this.basicInfo.price, this.basicInfo.originalPrice)
      if (Number(this.basicInfo.price) > Number(this.basicInfo.originalPrice)) {
        this.$message.error('套餐价格不能高于原价')
        return
      }
      this.basicInfo.configDetailList = this.legalRightList.map(a => {
        return a.name
      })
      console.log('this.basicInfo.photoUrl', this.basicInfo.photoUrl)
      let photoUrl = null
      if (this.basicInfo.photoUrl && this.basicInfo.photoUrl.length > 0) {
        photoUrl = this.basicInfo.photoUrl[0].url
      } else {
        photoUrl = null
      }
      membershipPlanAdd({ ...this.basicInfo, photoUrl: photoUrl, systemCode: this.$route.query.systemCode }).then((res) => {
        if (res.data.success) {
          this.$message.success('新增成功')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
